module.exports = __webpack_public_path__ + "static/media/ghs2.0fa21aeb.jpeg";